// Utility to get URL parameters that works with both HashRouter and BrowserRouter
export const getUrlParams = (location) => {
  // First check if there are params in the regular search (for Firebase direct URLs)
  if (location.search) {
    return new URLSearchParams(location.search);
  }
  
  // For HashRouter, the search params might be in the hash
  if (location.hash) {
    const hashParts = location.hash.split('?');
    if (hashParts.length > 1) {
      return new URLSearchParams(hashParts[1]);
    }
  }
  
  // Return empty params if none found
  return new URLSearchParams();
};

// Get a specific parameter
export const getUrlParam = (location, paramName) => {
  const params = getUrlParams(location);
  return params.get(paramName);
};
